var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"naj-loader",attrs:{"indeterminate":"","color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }